module.exports = __webpack_public_path__ + "media/images/img-archer-5281288b4f4cce77bf7b78f8c69bbcc0.png";